import React, {useEffect, useState} from "react";
// reactstrap components
import {Button, Card, CardBody, CardTitle, Col, Container, FormGroup, Modal, Row} from "reactstrap";
// core components
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../../components/Alerts/ErrorModal";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import SubscriptionHeader from "../../components/Headers/SubscriptionHeader";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import Select from "react-select";
import businessHelper from "../../helpers/BusinessHelper";
import {Redirect} from "react-router-dom";
import businessApiService from "../../api/business-api-service";
import reportApiService from "../../api/report-api-service";
import {isMobile} from 'react-device-detect';

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const Subscriptions = (props) => {
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const [selectedPos, setSelectedPos] = useState(null);
    const [highlightedSubscription, setHighlightedSubscription] = useState(subscriptionHelpers.currentProducts()[1]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showError, setShowError] = useState(null);
    const [yearlySwitchOn, setYearlySwitchOn] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(subscriptionHelpers.availableCurrencies()[0]);
    const [goToProfile, setGoToProfile] = useState(false);
    const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
    const [applyDiscount, setApplyDiscount] = useState(false);
    const [discountCode, setDiscountCode] = useState("");

    useEffect(() => {
        reportApiService.ahoy("subscriptions_view")
    }, []);

    function checkReload() {
        if (localStorage.must_reload === true || localStorage.must_reload === "true") {
            localStorage.must_reload = false
            window.location.reload()
        }
    }

    function toggleErrorModal() {
        setShowError(!showError)
    }

    function curProducts() {
        return subscriptionHelpers.currentProducts(selectedCurrency.value, yearlySwitchOn);
    }

    function subscriptionHovered(pos) {
        if (selectedSubscription === null) {
            setHighlightedSubscription(curProducts()[pos])
        } else {
            setHighlightedSubscription(selectedSubscription)
        }
    }

    function isCurrentlyHighlighted(pos) {
        return curProducts()[pos].plan === highlightedSubscription.plan
    }

    function isSelectedSubscription(pos) {
        if (selectedSubscription === null) return false;
        else return curProducts()[pos].plan === selectedSubscription.plan
    }

    function itemClassName(pos) {
        if (isCurrentlyHighlighted(pos)) {
            return "bg-gradient-default shadow mb-4 align-items-center"
        } else {
            return "bg-gradient-secondary shadow mb-4 align-items-center"
        }
    }

    function itemPriceClassName(pos) {
        if (isCurrentlyHighlighted(pos)) {
            return applyDiscount ? "mt-3 text-white text-through" : "mt-3 text-white"
        } else {
            return applyDiscount ? "mt-3 text-black text-through" : "mt-3 text-black"
        }
    }

    function itemDiscountPriceClassName(pos) {
        if (isCurrentlyHighlighted(pos)) {
            return "mt-3 text-white"
        } else {
            return "mt-3 text-black"
        }
    }

    function itemTextClassName(pos) {
        if (isCurrentlyHighlighted(pos)) {
            return "text-uppercase text-white mb-0"
        } else {
            return "text-uppercase text-gray mb-0"
        }
    }

    function itemDescriptionClassName(pos) {
        if (isCurrentlyHighlighted(pos)) {
            return "mt-3 mb-0 text-white text-sm"
        } else {
            return "mt-3 mb-0 text-gray text-sm"
        }
    }

    function itemName(pos) {
        return curProducts()[pos].title
    }

    function itemDescription(pos) {
        return curProducts()[pos].description
    }

    function calcDiscountIfNeeded(priceString) {
        if (!applyDiscount) {
            return priceString
        } else {
            let price = 0
            switch (discountCode) {
                case "OPENFRIEND":
                    price = parseFloat(priceString)
                    return (price - (price * 0.4)).toFixed(2)
                case "DEENAOPEN":
                    price = parseFloat(priceString)
                    return (price - (price * 0.4)).toFixed(2)
                case "ANANDA-20":
                    price = parseFloat(priceString)
                    return (price - (price * 0.2)).toFixed(2)
                case "OPENSTART":
                    price = parseFloat(priceString)
                    return (price - (price * 0.2)).toFixed(2)
                default:
                    return parseFloat(priceString).toFixed(2)
            }

        }
    }

    function itemPrice(pos) {
        return curProducts()[pos].currencySymbol + " " + curProducts()[pos].price.toFixed(2) + " / "
            + (yearlySwitchOn ? commonStrings.year.toLowerCase() : commonStrings.month.toLowerCase())
    }

    function itemDiscountPrice(pos) {
        return curProducts()[pos].currencySymbol + " " + calcDiscountIfNeeded(curProducts()[pos].price.toFixed(2)) + " / "
            + (yearlySwitchOn ? commonStrings.year.toLowerCase() : commonStrings.month.toLowerCase())
    }

    localize();
    checkReload();

    function updateHighlighted() {
        setHighlightedSubscription(curProducts()[1]);
    }

    function toggleYearly() {
        setYearlySwitchOn(!yearlySwitchOn);
        setTimeout(function () {
            updateHighlighted()
        }, 5000);
    }

    function showOption(pos) {
        return selectedSubscription === null || curProducts()[pos].plan === selectedSubscription.plan
    }

    function cardLgOption(pos) {
        return (selectedSubscription !== null && curProducts()[pos].plan === selectedSubscription.plan) ? "6" : "4"
    }

    const handleCurrencySelected = value => {
        reportApiService.ahoy("subscriptions_cur_selected", {currency: value})
        setSelectedCurrency(value)
    };

    if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
        return <Redirect from="*" to="/auth/login"/>
    }

    function handleSubmit(e) {
        setLoading(true);
        e.preventDefault();

        businessApiService.createPaymentSession(selectedSubscription.id)
            .then(result => {
                setLoading(false);
                if (result.url) {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = result.url;
                    a.click();
                    document.body.removeChild(a);

                } else handleNetworkError(result);
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    return (
        <LoadingOverlay
            active={isLoading}
            spinner={<RotateCircleLoading color="white"/>}
            text=''
        >
            <>
                {showCancelConfirmation === true && renderCancelConfirmation()}

                {goToProfile === true &&
                <Redirect from="*" to="/admin/user-profile"/>
                }

                {error !== null && <ErrorModal showError={showError} error={error}
                                               toggleErrorModal={toggleErrorModal}/>}

                <SubscriptionHeader
                    showButtons={selectedSubscription !== null}
                    cancelSubscription={askCancelConfirmation}
                    enableFreeTrial={enableFreeTrial}
                    onCodeInput={onCodeInput}
                    applyDiscount={applyDiscount}
                    discountCode={discountCode}
                />
                {/* Page content */}
                <Container className="mt--7" fluid>
                    <Row className="mt-5">
                        <div className="col text-center">
                            <Card className="bg-secondary shadow text-center">
                                {/*<CardHeader className="bg-transparent border-0">*/}
                                {/*    <h4 className="text-default mb-0">{resourceStrings.subscriptions.selects_subscription}</h4>*/}
                                {/*</CardHeader>*/}
                                <Row className="text-center mt-4 ml-5 mb-4">
                                    {selectedSubscription === null &&
                                    <div className="text-center">
                                        <label className="custom-toggle"
                                               style={{margin: 0}}>
                                            <input type="checkbox"
                                                   color="success"
                                                   onChange={() => toggleYearly()}
                                                   id="public-slider"/>
                                            <span className="custom-toggle-slider rounded-circle"/>
                                        </label>
                                    </div>
                                    }
                                    {selectedSubscription !== null &&
                                    <Button
                                        color="secondary"
                                        style={{marginTop: "4rem"}}
                                        size="lg"
                                        onClick={() => setSelectedSubscription(null)}>
                                        {resourceStrings.subscriptions.pick_another}
                                    </Button>
                                    }
                                    {selectedSubscription === null &&
                                    <div
                                        className={yearlySwitchOn ? "text-center ml-1 text-primary" : "text-center ml-1 text-muted"}>
                                        {resourceStrings.subscriptions.billed_annually}
                                    </div>
                                    }
                                </Row>

                                <Row className="ml-4 mr-4 align-items-center align-content-center">
                                    {showOption(0) === true &&
                                    <Col lg={cardLgOption(0)}>
                                        <Card className={itemClassName(0)}
                                              style={{cursor: "pointer"}}
                                              onClick={() => showSubscription(0)}>
                                            <CardBody className="text-center"
                                                      onMouseEnter={() => subscriptionHovered(0)}>
                                                <Row>
                                                    <div className="col align-content-center">
                                                        <CardTitle
                                                            style={{textAlign: "center", verticalAlign: "middle"}}
                                                            tag="h5"
                                                            className={itemTextClassName(0)}
                                                        >
                                                            {itemName(0)}
                                                        </CardTitle>

                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemPriceClassName(0)}>{itemPrice(0)}</h2>

                                                        {applyDiscount &&
                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemDiscountPriceClassName(0)}>{itemDiscountPrice(0)}</h2>
                                                        }

                                                        <p className={itemDescriptionClassName(0)}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{itemDescription(0)}</span>
                                                        </p>

                                                        {isSelectedSubscription(0) === false &&
                                                        <Button
                                                            color="warning"
                                                            style={{marginTop: "4rem"}}
                                                            size="lg"
                                                            onClick={() => showSubscription(0)}>
                                                            {resourceStrings.subscriptions.proceed}
                                                        </Button>
                                                        }
                                                    </div>

                                                </Row>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                    }
                                    {showOption(1) === true &&
                                    <Col lg={cardLgOption(1)}>
                                        <Card className={itemClassName(1)}
                                              style={{cursor: "pointer"}}
                                              onClick={() => showSubscription(1)}>
                                            <CardBody className="text-center"
                                                      onMouseEnter={() => subscriptionHovered(1)}>
                                                <Row>
                                                    <div className="col align-content-center">
                                                        <CardTitle
                                                            style={{textAlign: "center", verticalAlign: "middle"}}
                                                            tag="h5"
                                                            className={itemTextClassName(1)}
                                                        >
                                                            {itemName(1)}
                                                        </CardTitle>

                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemPriceClassName(1)}>{itemPrice(1)}</h2>

                                                        {applyDiscount &&
                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemDiscountPriceClassName(1)}>{itemDiscountPrice(1)}</h2>
                                                        }

                                                        <p className={itemDescriptionClassName(1)}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{itemDescription(1)}</span>
                                                        </p>

                                                        {isSelectedSubscription(1) === false &&
                                                        <Button
                                                            color="warning"
                                                            style={{marginTop: "4rem"}}
                                                            size="lg"
                                                            onClick={() => showSubscription(1)}>
                                                            {resourceStrings.subscriptions.proceed}
                                                        </Button>
                                                        }
                                                    </div>

                                                </Row>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                    }
                                    {showOption(2) === true &&
                                    <Col lg={cardLgOption(2)}>
                                        <Card className={itemClassName(2)}
                                              style={{cursor: "pointer"}}
                                              onClick={() => showSubscription(2)}>
                                            <CardBody className="text-center"
                                                      onMouseEnter={() => subscriptionHovered(2)}>
                                                <Row>
                                                    <div className="col align-content-center">
                                                        <CardTitle
                                                            style={{textAlign: "center", verticalAlign: "middle"}}
                                                            tag="h5"
                                                            className={itemTextClassName(2)}
                                                        >
                                                            {itemName(2)}
                                                        </CardTitle>

                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemPriceClassName(2)}>{itemPrice(2)}</h2>

                                                        {applyDiscount &&
                                                        <h2 style={{textAlign: "center", verticalAlign: "middle"}}
                                                            className={itemDiscountPriceClassName(2)}>{itemDiscountPrice(2)}</h2>
                                                        }

                                                        <p className={itemDescriptionClassName(2)}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>{itemDescription(2)}</span>
                                                        </p>

                                                        {isSelectedSubscription(2) === false &&
                                                        <Button
                                                            color="warning"
                                                            style={{marginTop: "4rem"}}
                                                            size="lg"
                                                            onClick={() => showSubscription(2)}>
                                                            {resourceStrings.subscriptions.proceed}
                                                        </Button>
                                                        }
                                                    </div>

                                                </Row>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                    }
                                    <Col lg={selectedSubscription === null ? "0" : "6"}>
                                        {selectedSubscription !== null &&
                                        <Card className="bg-gradient-success shadow mb-4 align-items-center"
                                              style={{padding: "2rem"}}>
                                            <div className="text-white mb-5 ml-2 mr-2">
                                                <small  className="text-white">{resourceStrings.formatString(resourceStrings.subscriptions.subscribe_expl,
                                                    yearlySwitchOn ? resourceStrings.subscriptions.yearly : resourceStrings.subscriptions.monthly)}</small>
                                            </div>

                                            <div className="text-white mb-5 ml-2 mr-2">
                                                {applyDiscount ?
                                                    (
                                                        <h4 className="text-white">{resourceStrings.formatString(resourceStrings.subscriptions.you_will_be_charged,
                                                            itemDiscountPrice(selectedPos))}
                                                        </h4>) :
                                                    (
                                                        <h4  className="text-white">{resourceStrings.formatString(resourceStrings.subscriptions.you_will_be_charged,
                                                            itemPrice(selectedPos))}
                                                        </h4>)
                                                }
                                            </div>
                                            <div className="text-center" style={{width: "300px"}}>
                                                <Button
                                                    style={{marginTop: "2rem"}}
                                                    type="submit"
                                                    color="warning"
                                                    onClick={e => handleSubmit(e)}
                                                    size="lg"
                                                >
                                                    {resourceStrings.subscriptions.subscribe}
                                                </Button>
                                            </div>
                                        </Card>
                                        }
                                    </Col>
                                </Row>

                                {selectedSubscription == null &&
                                <div className="ml-4 text-left">
                                    <Col lg="3">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-currency"
                                            >
                                                {commonStrings.business.currency}
                                            </label>
                                            <Select
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)'
                                                }}
                                                className="form-control-alternative"
                                                value={selectedCurrency}
                                                onChange={handleCurrencySelected}
                                                options={subscriptionHelpers.availableCurrencies()}
                                            />
                                        </FormGroup>
                                    </Col>

                                </div>
                                }

                            </Card>

                            <Card className={"bg-gray-dark shadow mb-4 align-items-center mt-4"}>
                                <CardBody className="text-center">
                                    <Row>
                                        <div className="col align-content-center">
                                            <CardTitle
                                                style={{textAlign: "center", verticalAlign: "middle"}}
                                                tag="h5"
                                                className={"text-uppercase text-white mb-0"}
                                            >
                                            </CardTitle>
                                            <div className="text-white" style={{display: "flex", flexFlow: isMobile ? "column" : "row", alignItems: "baseline"}}>
                                                {subscriptionHelpers.testimonials().map((testimonial) => {
                                                    return (
                                                        <div style={{marginRight: 50, padding: 10}}>
                                                            <img
                                                                src={testimonial.url}
                                                                alt="client"
                                                                style={{borderRadius: "10%", width: 70, margin: 5}}
                                                            />
                                                            <h3 className="text-white">{testimonial.name}</h3>
                                                            <label style={{marginTop: 10, textAlign: "left", maxWidth: 400}}>{testimonial.text}</label>
                                                        </div>
                                                    )
                                                })}
                                            </div>


                                        </div>

                                    </Row>

                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        </LoadingOverlay>
    );

    function handleNetworkError(e) {
        setIsLoading(false);
        setError(e);
        setShowError(true);
    }

    function localize() {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    function showSubscription(pos) {
        setSelectedPos(pos);
        setSelectedSubscription(curProducts()[pos])
    }

    function onCodeInput(e) {
        const value = e.target.value.trim();

        if (value && value.length > 8) {
            checkCouponCode(value)
        }
    }

    function checkCouponCode(code) {
        setLoading(true);
        console.log(code)

        businessApiService.checkCouponCode(code)
            .then(res => {
                setIsLoading(false);
                handleCodeCheckResult(res);
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function handleCodeCheckResult(result) {
        if (result.result === "true" || result.result === true) {
            setApplyDiscount(true)
            setDiscountCode(result.code)
        }
    }

    function enableFreeTrial() {
        setLoading(true);

        businessApiService.enableFreeTrial()
            .then(res => {
                setIsLoading(false);
                setGoToProfile(true)
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function askCancelConfirmation() {
        setShowCancelConfirmation(true)
    }

    function cancelSubscription() {
        setIsLoading(true);

        businessApiService.cancelSubscription()
            .then(res => {
                if (!res.message) {
                    setIsLoading(false);
                    businessHelper.saveUserSession(res);
                    alert(resourceStrings.subscriptions.subscription_cancelled);
                    setGoToProfile(true)
                } else handleNetworkError({message: res.message})
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function setLoading(loading) {
        setIsLoading(loading);
    }

    function toggleCancelConfirmationModal() {
        setShowCancelConfirmation(!showCancelConfirmation)
    }

    function renderCancelConfirmation() {
        return <Modal
            className="modal-dialog-centered modal-warning"
            contentClassName="bg-gradient-warning"
            isOpen={showCancelConfirmation}
            toggle={toggleCancelConfirmationModal}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleCancelConfirmationModal}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-exclamation-circle"/>
                    <h4 className="heading mt-4">{alertStrings.confirmation_alert_title}</h4>
                    <p>
                        {resourceStrings.subscriptions.cancel_confirmation}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleCancelConfirmationModal}
                >
                    {alertStrings.no}
                </Button>
                <Button className="btn-white" color="default" type="button"
                        onClick={() => cancelSubscription()}>
                    {alertStrings.yes}
                </Button>
            </div>
        </Modal>
    }
};

let reportStrings = new LocalizedStrings(report_strings);

export default Subscriptions;
